<template>
  <div>
    <div class="rpg-pd-5-10 rpg-bd-b">
      <div class="rpg-pd-5-10 rpg-bd-b">
        <label class="rpg-label">匹配度：</label>
        <el-radio v-model="pipeiduStr" label="非常匹配">非常匹配</el-radio>
        <el-radio v-model="pipeiduStr" label="一般匹配">一般匹配</el-radio>
        <!-- <span style="font-size:14px;float:right">
          <span style="color:#888">
            <el-tooltip placement="top" content="根据下面匹配度标签系统自动计算的建议匹配度">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            建议匹配度：
          </span>
          <span>{{recommendStatus}}</span>
        </span> -->
      </div>
      <table v-if="pipeiReady" class="simple-table" style="width:100%">
        <tr>
          <th>类型</th>
          <th>标签</th>
          <th>项目要求</th>
          <th>人选标签</th>
          <th style="width:100px">匹配度</th>
        </tr>
        <template v-for="(items, type) in pipei">
          <tr v-for="(item, k) in items" :key="type + k">
            <td v-if="k === 0" :rowspan="items.length">{{ type }}</td>
            <template v-if="item.label != '核心要求'">
              <td>{{ item.label }}</td>
              <td>{{ item.tags.join('、') }}</td>
              <td>
                <el-select
                  v-if="mapType(item.prop) == 'select'"
                  v-model="item.val"
                  size="mini"
                  filterable
                  :placeholder="item.prop"
                  @change="changeData(item)"
                >
                  <template v-if="Array.isArray(options[item.prop])">
                    <el-option v-for="op in options[item.prop]" :value="op" :key="op" :label="op || '--'"></el-option>
                  </template>
                  <template v-else>
                    <el-option v-for="(v, k) in options[item.prop]" :value="k" :key="k" :label="v || '--'"></el-option>
                  </template>
                </el-select>
                <el-select
                  v-else-if="mapType(item.prop) == 'multSelect'"
                  v-model="item.val"
                  size="mini"
                  filterable
                  multiple
                  :placeholder="item.prop"
                  @change="changeData(item)"
                >
                  <template v-if="Array.isArray(options[item.prop])">
                    <el-option v-for="op in options[item.prop]" :value="op" :key="op" :label="op || '--'"></el-option>
                  </template>
                  <template v-else>
                    <el-option v-for="(v, k) in options[item.prop]" :value="k" :key="k" :label="v || '--'"></el-option>
                  </template>
                </el-select>
                <div v-else class="el-input el-input--mini">
                  <input
                    type="text"
                    autocomplete="off"
                    v-model="item.val"
                    :placeholder="item.prop"
                    class="el-input__inner"
                    @change="changeData(item)"
                  />
                </div>
              </td>
              <td>
                <div v-if="item.isPipei === true" style="background:#0c0;color:#fff">符合</div>
                <div v-else-if="item.isPipei === false" style="background:#c00;color:#fff">不符合</div>
                <div v-else>数据不全，请补充</div>
              </td>
            </template>
            <template v-else>
              <td colspan="3">{{ item.tag }}</td>
              <td class="pi-td">
                <input type="radio" id="one" :value="true" v-model="item.isPipei" /> <label for="one">符合</label>
                <input type="radio" id="two" :value="false" v-model="item.isPipei" /> <label for="two">不符合</label>
              </td>
            </template>
          </tr>
        </template>
      </table>
    </div>
    <div class="rpg-pd-5-10 rpg-text-center" v-if="isConfirmShow">
      <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
    </div>
  </div>
</template>
<script>
import { hasIntersection, getAge } from '../constant/common-methods'
import ViewItem from '../detail/view-item'
import { options } from '../detail/options'
export default {
  components: { ViewItem },
  props: {
    isConfirmShow: {
      type: Boolean,
      default: false,
    },
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      radishData: {},
      pipei: {},
      fieldMap: {
        倾向学历: '学历标签',
        学历要求: '学历',
        目标行业: '行业',
        语言能力: '语言标签',
        领导能力: '领导力',
        '心态/性格': '心态个性',
        倾向年龄: '出生年月',
        工作年限: '从业起始年',
        专业能力: '专业因素',
      },
      options,
      pipeiReady: true,
      pipeiduStr: '',
      recommendStatus: ''
    }
  },
  async mounted() {
    const rid = this.radish.rid || this.radish._id
    const pid = this.project._id
    const res = await app.service('radish').getRadishProject({ rid, pid })
    let oldPi = []
    if (res.status == 'success' && res.data) {
      if (res.data.pipeiduStr) this.pipeiduStr = res.data.pipeiduStr
      if (res.data.pipeidu) {
        oldPi = res.data.pipeidu.必须.concat(res.data.pipeidu.优先).concat(res.data.pipeidu.其他)
        oldPi = oldPi.filter(o => o.label == '核心要求')
      }
    }
    this.radishData = JSON.parse(JSON.stringify(this.radish))
    const result = this.project.标签分类 || {}
    const bixu = result.必须 || []
    const youxian = result.优先 || []
    const qita = result.其他 || []
    const bixuRes = {}
    const youxianRes = {}
    const qitaRes = {}
    bixu.forEach((v, k) => {
      if (v.label == '核心要求') {
        bixuRes[v.label + k] = v
        const old = oldPi.filter(o => o.tag == v.tag)
        if (old.length > 0) bixuRes[v.label + k].isPipei = old[0].isPipei
      } else if (!bixuRes[v.label]) {
        v.tags = [v.tag]
        bixuRes[v.label] = v
      } else {
        bixuRes[v.label].tags.push(v.tag)
      }
    })
    youxian.forEach((v, k) => {
      if (v.label == '核心要求') {
        youxianRes[v.label + k] = v
        const old = oldPi.filter(o => o.tag == v.tag)
        if (old.length > 0) youxianRes[v.label + k].isPipei = old[0].isPipei
      } else if (!youxianRes[v.label]) {
        v.tags = [v.tag]
        youxianRes[v.label] = v
      } else {
        youxianRes[v.label].tags.push(v.tag)
      }
    })
    qita.forEach((v, k) => {
      if (v.label == '核心要求') {
        qitaRes[v.label + k] = v
        const old = oldPi.filter(o => o.tag == v.tag)
        if (old.length > 0) qitaRes[v.label + k].isPipei = old[0].isPipei
      } else if (!qitaRes[v.label]) {
        v.tags = [v.tag]
        qitaRes[v.label] = v
      } else {
        qitaRes[v.label].tags.push(v.tag)
      }
    })
    const bixu1 = Object.values(bixuRes)
    const youxian1 = Object.values(youxianRes)
    const qita1 = Object.values(qitaRes)
    const pipei = {
      必须: bixu1,
      优先: youxian1,
      其他: qita1,
    }
    this.setPipei(pipei)
  },
  methods: {
    mapType(prop) {
      const select = ['性别', '婚育', '业绩', '学历', '平台', '行业', '职级', '专业职级']
      const multSelect = [
        '职能模块',
        '地域',
        '职业资格',
        '细分职能',
        '擅长方向',
        '语言标签',
        '个人风格',
        '心态个性',
        '学历标签',
        '领导力',
        '专业因素',
      ]
      if (select.includes(prop)) return 'select'
      if (multSelect.includes(prop)) return 'multSelect'
    },
    async changeData(item) {
      this.pipeiReady = false
      const obj = {}
      obj[item.prop] = item.val
      const result = await app.service('radish').modifyById({ _id: this.radish.rid || this.radish._id, data: obj })
      if (result.status == 'success') {
        const blankEl = this.$parent.$parent.setRadish ? this.$parent.$parent : this.$parent.$parent.$parent
        if (blankEl.setRadish) {
          blankEl.setRadish(obj)
          blankEl.$refs.DetailEdit && Object.assign(blankEl.$refs.DetailEdit.formData, obj)
        }
        this.radishData[item.prop] = item.val
        this.$message.success({ duration: 500, message: '修改成功' })
        this.setPipei()
      } else {
        this.$message.error(result.msg)
      }
      this.pipeiReady = true
    },
    setPipei(pipei) {
      if (!pipei) pipei = JSON.parse(JSON.stringify(this.pipei))
      for (const key in pipei) {
        const items = pipei[key]
        items.forEach(item => {
          item.prop = this.fieldMap[item.label] || item.label
          if (item.label !== '核心要求') {
            item.val = this.radishData[item.prop]
          }
          if (!item.val || (Array.isArray(item.val) && item.val.length == 0)) return false
          if (item.tags.includes('不限')) {
            item.isPipei = true
          } else if (item.label == '倾向年龄') {
            const ageArr = item.tag.split('--')
            const age = getAge(item.val)
            item.isPipei =
              age &&
              ((ageArr[0] && !ageArr[1] && ageArr[0] <= age) ||
                (ageArr[1] && !ageArr[0] && ageArr[1] >= age) ||
                (ageArr[0] && ageArr[0] <= age && ageArr[1] && ageArr[1] >= age))
          } else if (item.label == '工作年限') {
            const expYear = getAge(item.val)
            const expArr = item.tag.split('--')
            item.isPipei =
              expYear &&
              ((expArr[0] && !expArr[1] && expArr[0] <= expYear) ||
                (expArr[1] && !expArr[0] && expArr[1] >= expYear) ||
                (expArr[0] && expArr[0] <= expYear && expArr[1] && expArr[1] >= expYear))
            // if (expYear !== null) {
            //   switch (item.tag) {
            //     case '无经验':
            //       item.isPipei = false
            //       break
            //     case '3年以下':
            //       item.isPipei = expYear <= 3
            //       break
            //     case '3-5年':
            //       item.isPipei = expYear >= 3 && expYear <= 5
            //       break
            //     case '5-8年':
            //       item.isPipei = expYear >= 5 && expYear <= 8
            //       break
            //     case '8年以上':
            //       item.isPipei = expYear >= 8
            //       break
            //   }
            // }
          } else if (item.label == '学历要求') {
            const xueliMap = {
              博士后: 6,
              博士: 5,
              硕士: 4,
              本科: 3,
              大专: 2,
              中专: 1,
            }
            item.isPipei = xueliMap[item.val] >= xueliMap[item.tag]
          } else {
            if (Array.isArray(item.val)) {
              item.isPipei = hasIntersection(item.tags, item.val)
            } else {
              item.isPipei = item.tags.includes(item.val)
            }
          }
        })
      }
      this.pipei = pipei
      // this.getRecommendStatus()
    },

    recommendText() {
      const zhijiMap = {
        '1': '高管',
        '2': '部门总',
        '3': '部门副总/总助/团队长',
        '4': '部门核心骨干',
        '5': '新人三年以下',
      }
      const rd = this.radishData
      const age = rd.出生年月 ? `年龄在${getAge(rd.出生年月)}岁，` : ''
      const city = rd.地域 && rd.地域.length > 0 ? `日常工作地点为${rd.地域.join('、')}，` : ''
      const yuanxiao = rd.硕士院校 || rd.本科院校
      const school = yuanxiao ? `毕业于${yuanxiao}，` : ''
      const xueli = rd.学历 ? `${rd.学历}学位` : ''
      const reg = /，$/gi
      let line1 = '人选' + age + city + school + xueli + '\n'
      const bixuFuhe = this.pipei.必须
        .filter(item => item.label !== '核心要求' && item.isPipei === true)
        .map(item => item.prop)
      const youxianFuhe = this.pipei.优先
        .filter(item => item.label !== '核心要求' && item.isPipei === true)
        .map(item => item.prop)
      const bixuBufuhe = this.pipei.必须
        .filter(item => item.label !== '核心要求' && item.isPipei === false)
        .map(item => item.prop)
      const fuhe = bixuFuhe.concat(youxianFuhe)
      line1 = line1.replace(reg, '。')
      let line2 = ''
      if (
        fuhe.includes('细分职能') ||
        fuhe.includes('擅长方向') ||
        fuhe.includes('投资风格') ||
        fuhe.includes('职业资格') ||
        fuhe.includes('行业')
      ) {
        line2 += '人选'
        if (fuhe.includes('细分职能')) line2 += `专注于${rd.细分职能.join('、')}领域工作，有丰富经验，`
        if (fuhe.includes('擅长方向')) line2 += `深耕${rd.擅长方向.join('、')}方向，取得过【...自行填写成绩】，`
        if (fuhe.includes('投资风格')) line2 += `擅长${rd.投资风格}风格的投资，`
        if (fuhe.includes('职业资格')) line2 += `已获得${rd.职业资格.join('、')}，功底扎实，`
        if (fuhe.includes('行业')) line2 += `从事${rd.行业}行业，`
        line2 += '\n'
      }
      if (fuhe.includes('平台') || (rd.业绩 && rd.业绩.indexOf('a') != -1) || fuhe.includes('从业起始年')) {
        line2 += '人选'
        if (fuhe.includes('平台')) {
          if (rd.平台 == 'A') {
            line2 += '目前就职于头部平台，'
          } else if (rd.平台 == 'B') {
            line2 += '目前就职于中型平台，'
          }
        }
        if (rd.业绩 == 'aaa') {
          line2 += '业绩非常优秀，'
        } else if (rd.业绩 == 'aa') {
          line2 += '业绩突出，'
        } else if (rd.业绩 == 'a') {
          line2 += '业绩较为优秀，'
        }
        if (fuhe.includes('从业起始年')) line2 += `拥有${getAge(rd.从业起始年)}年工作经验，`
        line2 += '\n'
      }
      if (fuhe.includes('职级') || fuhe.includes('管理职级') || fuhe.includes('专业职级')) {
        line2 += '人选'
        if (fuhe.includes('职级')) line2 += `于目前平台的职级为${zhijiMap[rd.职级]}，`
        if (fuhe.includes('管理职级')) line2 += `${rd.职级 ? '' : '于目前平台的'}管理职级为${rd.管理职级}，`
        if (fuhe.includes('专业职级'))
          line2 += `${rd.职级 || rd.管理职级 ? '' : '于目前平台的'}专业职级为${rd.专业职级}，`
        line2 += '\n'
      }
      if (
        (rd.语言标签 && rd.语言标签.length > 0) ||
        (rd.专业能力 && rd.专业能力.length > 0) ||
        (rd.个人风格 && rd.个人风格.length > 0) ||
        (rd.心态个性 && rd.心态个性.length > 0)
      ) {
        line2 += '人选'
        if (rd.语言标签 && rd.语言标签.length > 0) {
          if (rd.语言标签.includes('英文-1-母语水平')) {
            line2 += '英文可以作为母语交流，'
          } else if (rd.语言标签.includes('英文-2-工作语言')) {
            line2 += '英文可作为工作语言，'
          } else if (rd.语言标签.includes('英文-3-口语较弱')) {
            line2 += '英文水平可顺利读写，但是口语较弱，'
          }
          if (rd.语言标签.includes('粤语')) {
            line2 += '粤语水平较好，可作为工作语言，'
          }
          if (rd.语言标签.includes('日语')) {
            line2 += '日语水平较好，可作为工作语言，'
          }
          if (rd.语言标签.includes('法语')) {
            line2 += '法语水平较好，可作为工作语言，'
          }
        }
        if (rd.专业能力 && rd.专业能力.length > 0)
          line2 += `${rd.专业能力.join('、')}，符合公司对于人才专业能力的要求，`
        if (rd.个人风格 && rd.个人风格.length > 0)
          line2 += `在工作上个人风格较为${rd.个人风格.join('、')}，对于该岗位契合度很高，`
        if (rd.心态个性 && rd.心态个性.length > 0) line2 += `候选人${rd.心态个性.join('、')}`
      }
      line2 = line2.replace(reg, '。')
      let line3 = ''
      if (
        bixuBufuhe.includes('细分职能') ||
        bixuBufuhe.includes('擅长方向') ||
        bixuBufuhe.includes('投资风格') ||
        bixuBufuhe.includes('职业资格') ||
        bixuBufuhe.includes('行业')
      ) {
        line3 += '人选'
        if (bixuBufuhe.includes('细分职能')) line3 += `从事${rd.细分职能.join('、')}领域工作，与岗位要求存在差异，`
        if (bixuBufuhe.includes('擅长方向'))
          line3 += `深耕${rd.擅长方向.join(
            '、',
          )}方向，取得过【...自行填写成绩】，虽然与公司方向存在差异，但是【...自行填写优势】，`
        if (bixuBufuhe.includes('投资风格')) line3 += `擅长${rd.投资风格}风格的投资，`
        // 职业资格
        if (bixuBufuhe.includes('职业资格')) {
          const zigeArr = this.pipei.必须.filter(item => item.label == '职业资格' && item.isPipei === false)
          line3 += `还未获得${zigeArr[0].tags.join('、')}`
        }
        if (bixuBufuhe.includes('行业')) line3 += `从事${rd.行业}行业，与公司所在行业存在差异，`
        line3 += '\n'
      }
      if (bixuBufuhe.includes('平台') || bixuBufuhe.includes('从业起始年')) {
        line3 += '人选'
        if (bixuBufuhe.includes('平台')) {
          if (rd.平台 == 'A') {
            line3 += '目前就职于头部平台，与岗位要求略有不同，'
          } else if (rd.平台 == 'B') {
            line3 += '目前就职于中型平台，与岗位要求略有不同，'
          } else if (rd.平台 == 'C') {
            line3 += '目前就职于小平台，与岗位要求略有不同，'
          }
        }
        if (bixuBufuhe.includes('从业起始年'))
          line3 += `拥有${getAge(rd.从业起始年)}年工作经验，，与岗位对于工作经验的要求略有差异，`
        line3 += '\n'
      }
      if (bixuBufuhe.includes('职级') || bixuBufuhe.includes('管理职级') || bixuBufuhe.includes('专业职级')) {
        line3 += '人选'
        if (bixuBufuhe.includes('职级')) line3 += `于目前平台的职级为${zhijiMap[rd.职级]}，`
        if (bixuBufuhe.includes('管理职级')) line3 += `${rd.职级 ? '' : '于目前平台的'}管理职级为${rd.管理职级}，`
        if (bixuBufuhe.includes('专业职级'))
          line3 += `${rd.职级 || rd.管理职级 ? '' : '于目前平台的'}专业职级为${rd.专业职级}，`
      }
      line3 = line3.replace(reg, '。')
      return line1 + '\n' + line2 + '\n' + line3
    },
    async getRecommendStatus() {
      const rid = this.radish.rid || this.radish._id
      const pid = this.project._id
      const res = await app.service('project').getRadishProjectRecommendStatus({rid, pid})
      if (res.status == 'success') {
        this.recommendStatus = res.data || '无'
      }
    },
    async handleConfirm() {
      const rid = this.radish.rid || this.radish._id
      const pid = this.project._id
      const param = { rid, pid, data: { pipeidu: this.pipei, pipeiduText: this.recommendText(), pipeiduStr: this.pipeiduStr } }
      const res = await app.service('radish').modifyRadishProject(param)
      if (res.status == 'success') {
        this.onConfirm({rid, pid, pipeiduStr: this.pipeiduStr})
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
      return this.pipei
    },
  },
}
</script>
<style>
.pi-td input {
  position: relative;
  top: 2px;
}
.pi-td label {
  margin-right: 5px;
  cursor: pointer;
}
</style>
